import { useCallback } from 'react';

// Performance-optimized TikTok tracking hook that prevents forced reflows
export const useTikTokTracking = () => {
  const trackConversion = useCallback((eventName: string, options?: any) => {
    // Use requestIdleCallback to prevent forced reflows
    const performTracking = () => {
      if (typeof window !== 'undefined' && (window as any).ttq) {
        try {
          (window as any).ttq.track(eventName, options);
        } catch (error) {
          console.warn('TikTok tracking error:', error);
        }
      }
    };

    if (typeof window !== 'undefined') {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(performTracking);
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(performTracking, 0);
      }
    }
  }, []);

  return { trackConversion };
};